import { render, staticRenderFns } from "./RequirementDocumentType.vue?vue&type=template&id=6fbe0b32&scoped=true"
import script from "./RequirementDocumentType.vue?vue&type=script&lang=js"
export * from "./RequirementDocumentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbe0b32",
  null
  
)

export default component.exports